/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import * as React from 'react';

import { IPromoOptionContainerItemProps, IPromoOptionContainerViewProps } from './promo-option-container';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';

const ItemComponent: React.FC<IPromoOptionContainerItemProps> = ({ itemProps, item }) => (
    <>
        <Node {...itemProps}>{item}</Node>
    </>
);

export default (props: IPromoOptionContainerViewProps) => {
    const { items, promoOptionContainerModuleProps } = props;

    return (
        <Module {...promoOptionContainerModuleProps}>
            {items.map(item => (
                <ItemComponent key={item.id} {...item} />
            ))}
        </Module>
    );
};
